import _ from 'lodash';

const maxDistancePermittedBeetwenMapPoints = 100;
const maxToleranceBeetwenMapPoints = 10;

function parseMapRoute(placeDetails) {
  return parseMapComponent(placeDetails, 'route');
}

function parseMapStreetNumber(placeDetails) {
  return parseMapComponent(placeDetails, 'street_number');
}

function parseMapPostalCode(placeDetails) {
  return parseMapComponent(placeDetails, 'postal_code');
}

function parseMapComplement(placeDetails) {
  if (_.isEmpty(placeDetails)) return null;

  let result = '';

  if (placeDetails.types.includes('point_of_interest')) {
    result += `${placeDetails.name ?? ''}`;
  }

  result += `${parseMapComponent(placeDetails, 'premise') ?? ''}\n${parseMapComponent(placeDetails, 'subpremise') ?? ''}`;
  return result;
}

function parseMapComponent(placeDetails, type) {
  if (_.isEmpty(placeDetails?.address_components)) return null;

  const result = placeDetails?.address_components?.filter((component) =>
    component.types.includes(type)
  );

  return _.head(result)?.long_name;
}

export {
  parseMapRoute,
  parseMapStreetNumber,
  parseMapPostalCode,
  parseMapComplement,
  maxDistancePermittedBeetwenMapPoints,
  maxToleranceBeetwenMapPoints,
};
